const nameData = "ajustesDet";

export const fetchEntityData = async (
  getEntityPanelData,
  searchArtId,
  numPagina,
  filas,
  ajuid,
  setListaItems,
  setTotalItems,
  arrayDetalle
) => {
  try {
    let listaAjustes = [];
    let totalApiItems = 0;

    if (ajuid) {
      const data = await getEntityPanelData(ajuid, searchArtId, numPagina, filas);
      if (data) {
        listaAjustes = data.ajustesDet || [];
        totalApiItems = data.pagination?.totalItems || 0;
      }
    }
    const totalArrayItems = arrayDetalle.length;
    const totalItems = totalApiItems + totalArrayItems;
    const totalPages = Math.ceil(totalItems / filas) || 1;
    const combinedList = arrayDetalle.length > 0
      ? [...listaAjustes, ...arrayDetalle]
      : listaAjustes;
    const start = (totalArrayItems === 0) ? 0 : (numPagina - 1) * filas;
    const end = start + filas;
    const paginatedList = combinedList.slice(start, end);
    setListaItems(paginatedList);
    setTotalItems(totalItems);

    return { totalPages };
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};
export const deleteItem = async (selectedItem, arrayDetalle, removeItem) => {
  try {
    const detalleEnArray = arrayDetalle.find((item) => item.ajd_id === selectedItem);
    if (detalleEnArray) {
      removeItem(selectedItem);
    }

  } catch (error) {
    console.error("Ocurrió un error durante la eliminación:", error);
    throw error;
  }
};

